module.exports = __webpack_public_path__ + "media/4x3/fr-b1156355.svg";